import * as sessionSelectors from 'app_modules/session/selectors'
import actionTypes from 'app_modules/notifications/constants'
import api from 'api'

export const fetchWorkingCircleNotificationsRequest = () => ({
  type: actionTypes.FETCH_WORKING_CIRCLE_NOTIFICATIONS_REQUEST,
})

export const fetchWorkingCircleNotificationsSuccess = response => ({
  type: actionTypes.FETCH_WORKING_CIRCLE_NOTIFICATIONS_SUCCESS,
  payload: response,
})

export const fetchWorkingCircleNotificationsFailure = error => ({
  type: actionTypes.FETCH_WORKING_CIRCLE_NOTIFICATIONS_FAILURE,
  payload: error,
})

/**
 * GET /account/:accountId/notifications/working_circle
 * Loads pending working circle notifications (reciprocal + social_overlap) into Redux.
 *
 * @param {function} [onSuccess] - Called with the response on success.
 * @param {function} [onError]   - Called with the error on failure.
 */
export const fetchWorkingCircleNotifications = (onSuccess, onError) => {
  const thunk = (dispatch, getState) => {
    const accountId = sessionSelectors.accountId(getState())

    dispatch(fetchWorkingCircleNotificationsRequest())

    const handleResponse = response => {
      // BE returns { notifications: [...] } where each item already has a type field
      // ('reciprocal' or 'social_overlap') — use the array directly.
      const notifications = response.notifications || []
      dispatch(fetchWorkingCircleNotificationsSuccess({ notifications }))
      if (onSuccess) onSuccess(response)
    }

    const handleError = ({ error }) => {
      dispatch(fetchWorkingCircleNotificationsFailure(error))
      if (onError) onError(error)
      else throw error
    }

    return api.notifications.getWorkingCircleNotifications({ accountId }, handleResponse, handleError)
  }

  thunk.type = actionTypes.FETCH_WORKING_CIRCLE_NOTIFICATIONS
  return thunk
}

export default fetchWorkingCircleNotifications
